// client/src/TypingSocket.js
import { io } from "socket.io-client";

export const connectTypingSocket = () => {
  const SOCKET_URL = process.env.REACT_APP_SIDESERVER;

  return io(SOCKET_URL, {
    transports: ["polling", "websocket"], // 🔑 IMPORTANT
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    timeout: 20000,
      withCredentials: true,   // ← yahi credentials

  });
};
